import {renderInfoContent} from './renderInfo.js';
import listMapIt from './listMapIt.js';
import datalist from './util/datalist.js';
import {changePage} from './changePage.js';

// constructor
export default function() {

  /*
    validateSearch() is a private function which depends of some pretty funky stuff:
    * accessing by document.formName.elementName depends on the name or id not being hyphenated
    * assumes all counties have same <form> and <input> ids and names

    If 'this' got passed as 'thisForm' instead of form.id could do:
      thisForm['St_Name'].value
  */
  function validateSearch(form) {
    let fid = form.id;

    // if (form.action) {
    //   target = form.action;
    // }

    if (fid === 'ownerSearch'){
      if (document.ownerSearch.Last_Name.value === '') {
        alert('You must enter a last name (or at least part of one) for a property owner search.');
        return false;
      }
    } else if (fid === 'legalSearch') {
      if (form['legal'].value === '') {
        alert('You must enter a legal description (or at least part of one) for a legal search.');
        return false;
      }
    } else if (fid === 'addressSearch') {
      if (form['St_Name'].value === '') {
        if (form['road-list-input']) { // we would get here if user hit enter in road list <input>
          // could improve this. If they've entered something that has no matches then list is empty
          // and down arrow does nothing, so should clear list. But if there are matches in the list
          // it shouldn't be cleared.
          alert('Please enter a street name or select one from the list');
        } else {
          alert('You must enter a street name (or at least part of one) for a street address search.');
        }
        return false;
      }
    } else if (fid === 'numSearch') {
      if (document.numSearch.idnum.value === '') {
        alert('You must enter a PIDN (or at least part of one) or an Account Number');
        return false;
      }
    } else {
      return true;
    }
  }

  function renderJSONresults (results) {
    let resultsDiv = document.querySelector('#search_results');
    resultsDiv.innerHTML = '';
    // replace null with empty string using nullish coalescing operator
    const nullBeGone = (val) => val ?? ''
    if (results.length > 0) {
      results.forEach(rec => {
        let div = document.createElement('div');
        div.className = 'rwg-searchresult';
        div.innerHTML = nullBeGone(rec.name1) + ' ' + nullBeGone(rec.name2) + '<br>' +
          nullBeGone(rec.st_address) + '<br>' +
          nullBeGone(rec.descript) + '&nbsp;';
        div.addEventListener('click', function() {
          rwg.map.getLayerByTitle('lyrVector').getSource().clear();
          rwg.mapFeatures(rec.labelpoint);
          rwg.mapFeatures(rec.polygeom);
          changePage('mappage');
          rwg.zoomToVectorExtents();  // switch to map before zooming to extent
        });
        resultsDiv.appendChild(div);
      })
    } else {  // empty response
      let div = document.createElement('div');
      div.className = 'rwg-searchresult';
      div.style.fontSize = 'large';
      div.innerHTML = 'Sorry, nothing found.';
      resultsDiv.appendChild(div);
    }
  }

  if (document.querySelector("button[id='btn-srch']")) {  // eslint-disable-line quotes
    document.querySelector("button[id='btn-srch']").style.display = '';  // eslint-disable-line quotes
  }

  /*
   * Attach a submit handler to the data-search-div which holds (almost) all
   * searchForms so when a form gets submitted this handler catches it.
   * 2023-10-17 this version uses FormData() and URLSearchParams() rather
   * than jQuery's serialize(). And uses fetch() than than jQuery.ajax().
  */
  document.querySelector('div[data-search-div]').addEventListener('submit', function(e) {
    e.preventDefault();
    const fid = e.target.id; // Form id

    // if not simple search, clear out the fulltext search because it still displays
    if (fid !== 'searchForm') {
      document.getElementById('ts').value = '';
    }
    if (validateSearch(e.target) === false ) { // should pass "this" instead of fid
      return false;
    }

    const formdata = new FormData(e.target)
    const params = new URLSearchParams(formdata)
    if (rwg.layout.get() === 'paged') {
      params.append('fmt', 'json')
    }

    fetch('tabList.php', {
      method: 'POST',
      body: params
    }).then(response => {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        response.json().then(data => {
          if (Array.isArray(data)) {  // presumably multiple search results from a request in paged layout
            renderJSONresults(data);
          } else {  // not an array so it's a single result in infotool format
            renderInfoContent(data, true);  // infotool
          }
        })
      } else {
        response.text().then(text => {
          rwg.tabs.activate('top-search')
          document.querySelector('#search_results').innerHTML = text;
        })
      }
    })

  });

  if (rwg.config.advancedSearch !== false) {  // Albany, Carbon & Platte Counties don't have advanced search
    fetch('etc/advanced_search.html')
    .then(response => response.text())
    .then(html => {
      document.querySelector('div[rwg-tab="srch-adv"]').innerHTML = html;

      // only Sweetwater, tetonwy & (tcwp) have road list
      let roadInput = document.querySelector('#road-list-input');
      if (roadInput) {
        datalist({
          dataURL: './etc/roads.json',
          element: roadInput,
          handler: id => { if (id) listMapIt('rd', id) }
        });
      }
      // only tetonwy & (tcwp) have subdiv list
      let subdivInput = document.querySelector('#subdiv-list-input');
      if (subdivInput) {
        datalist({
          dataURL: './etc/subdivs.json',
          element: subdivInput,
          handler: id => { if (id) listMapIt('sd', id) }
        });
      }
    })
  } else if (rwg.config.advancedSearch === false) {
    let element = document.getElementById('showMore') || document.getElementById('search-tabs');
    if (element) {
      element.style.display = 'none';
    }
  }
}
